import { useEffect, useState } from 'react';
import { getWallet } from '../api/wallets.api';
import type { Wallet } from '../types/wallet.types';

export function useWallet(id: string | undefined) {
  const [wallet, setWallet] = useState<Wallet | null>(null);
  const [loading, setLoading] = useState(Boolean(id));
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    setError(null);
    getWallet(id)
      .then(setWallet)
      .catch(() => setError('خطا در دریافت جزئیات کیف پول'))
      .finally(() => setLoading(false));
  }, [id]);

  return { wallet, loading, error };
}
